import { useTrackingEventsDatasNoItems } from "./useTracking";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingLeadFormError = () => {
    const EVENT_DATA = {
        ...useTrackingEventsDatasNoItems(true),
        event: "form_error",
        av_feature: "lead_classified_form",
    };
    return useTrackingEvent(EVENT_DATA);
};
